import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { InitialData } from '../models/initialData.model';
import { InitialService } from './app.initial.service';

/**
 * Route Resolver — fetches InitialData BEFORE the HomeComponent is activated.
 * This eliminates the race condition where the component rendered before the
 * async HTTP response arrived, causing the *ngIf="initialData" stepper to
 * not render on the first click of the IKTVA Registration tab.
 *
 * Angular waits for this resolver to complete before instantiating the component,
 * so initialData is always available synchronously in ngOnInit via ActivatedRoute.
 *
 * InitialService uses shareReplay(1) — subsequent navigations return the cached
 * value immediately with no additional HTTP call.
 */
@Injectable({ providedIn: 'root' })
export class InitialDataResolver implements Resolve<InitialData> {

  constructor(private initialService: InitialService) { }

  resolve(): Observable<InitialData> {
    return this.initialService.getInitialData();
  }
}
